"use client";

import { hasGoldenVisa } from "@/config/additionalSettings.config";
import { useSearchParams } from "next/navigation";

export const useIsGoldenVisaEligible = (): boolean => {
  const params = useSearchParams();
  return params.get("isGoldenVisaEligible") === "true" && hasGoldenVisa();
};
